__turbopack_context__.v({
  "blue-elements": "wrapper-module-scss-module__lV-wRq__blue-elements",
  "navbar": "wrapper-module-scss-module__lV-wRq__navbar",
  "navbar-to-blue": "wrapper-module-scss-module__lV-wRq__navbar-to-blue",
  "scrolled": "wrapper-module-scss-module__lV-wRq__scrolled",
});
